mutation ImportFeedFromUrl($campaignId: ID!, $url: String!) {
    importFeedFromUrl(campaignId: $campaignId, url: $url)
}
